var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDuplicate = function SvgDuplicate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    viewBox: "0 0 22 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M15.2 4.2V2a.2.2 0 0 0-.2-.2H2a.2.2 0 0 0-.2.2v13c0 .11.09.2.2.2h3.2V6A1.8 1.8 0 0 1 7 4.2h8.2Zm1.6 0H20A1.8 1.8 0 0 1 21.8 6v13a1.8 1.8 0 0 1-1.8 1.8H7A1.8 1.8 0 0 1 5.2 19v-2.2H2A1.8 1.8 0 0 1 .2 15V2A1.8 1.8 0 0 1 2 .2h13A1.8 1.8 0 0 1 16.8 2v2.2ZM7 5.8a.2.2 0 0 0-.2.2v13c0 .11.09.2.2.2h13a.2.2 0 0 0 .2-.2V6a.2.2 0 0 0-.2-.2H7Z"
  })));
};
export default SvgDuplicate;